<template>
  <el-dialog title="案件列表" :visible.sync="visible" width="620px" append-to-body>
    <div class="case-import-modal">
      <template v-if="showList">
        <div class="import-list-content" v-loading="tableInfo.loading">
          <el-radio-group
            v-model="tableInfo.type"
            @change="() => ((tableInfo.page = 1), getTableList())"
            v-if="showTypeGroup"
            :style="{ marginBottom: '10px' }"
          >
            <el-radio v-for="item in uniqEnumList" :key="item.type" :label="item.type">
              <span>{{ item.label }}</span>
            </el-radio>
          </el-radio-group>

          <div class="import-tip" :style="{ color: '#4e555b' }">
            <span>导入案件数共{{ uploadSuccess }}个</span>
            <template v-if="uploadDuplicateNumber > 0">
              <span>，其中重复案件数{{ uploadDuplicateNumber }}个</span>
              <span>（已用红色底纹标识），确认导入案件数{{ uploadSuccess - uploadDuplicateNumber }}个</span>
            </template>
          </div>

          <div class="import-table-content">
            <el-table
              :data="tableInfo.list"
              :row-class-name="({ row }) => (row._source.type === 'duplicate' ? 'duplicate-item' : '')"
            >
              <el-table-column
                label="序号"
                width="60"
                align="center"
                :formatter="(row, column, cellValue, index) => (tableInfo.page - 1) * tableInfo.size + (index + 1)"
              />
              <el-table-column prop="date" label="案号" width="240">
                <div slot-scope="{ row }" class="single-ellipsis">{{ row._source.base_caseNumber }}</div>
              </el-table-column>
              <el-table-column prop="name" label="标题">
                <div slot-scope="{ row }" class="single-ellipsis">{{ row._source.base_title }}</div>
              </el-table-column>
            </el-table>
          </div>

          <div class="pagination-content" v-if="tableInfo.total > tableInfo.size">
            <el-pagination
              layout="prev, pager, next"
              :total="tableInfo.total"
              :current-page.sync="tableInfo.page"
              :page-size="tableInfo.size"
              @current-change="getTableList()"
            />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="import-content">
          <div class="import-content-header">
            <span>请下载示例文档，参考文档格式填写内容，再导入案件</span>
            <el-button type="text" @click="downloadPreview">
              <i class="el-icon-download"></i>
              <span>示例文档</span>
            </el-button>
          </div>
          <div
            class="upload-content"
            v-if="showRunning"
            v-loading="showRunning"
            element-loading-text="正在导入案件，请稍等..."
          ></div>
          <div class="upload-content" v-else>
            <input class="upload-btn" type="file" accept=".doc,.docx,.zip" :disabled="loading" @change="fileChange" />
            <img :src="fileImg" class="upload-file-img" />
            <div class="upload-tip-title single-ellipsis">{{ file ? file.name : '点击导入案件' }}</div>
            <div class="upload-tip-desc">支持扩展名：.zip .doc .docx</div>
          </div>
        </div>
      </template>
    </div>
    <span slot="footer">
      <el-button @click="visible = false">关 闭</el-button>
      <template v-if="showRunning">
        <el-button type="danger" plain :loading="loading" @click="cancelHandle">取消导入</el-button>
      </template>
      <template v-else-if="showList">
        <el-button type="danger" plain :loading="loading && handleType === 'cancel'" @click="cancelHandle"
          >取消导入</el-button
        >
        <el-button
          type="primary"
          :loading="loading && handleType === 'confirm'"
          @click="confirmHandle"
          :disabled="uploadSuccess <= uploadDuplicateNumber"
          >确认导入</el-button
        >
      </template>
      <template v-else>
        <el-button type="primary" :loading="loading" @click="createTaskHandle">下一步</el-button>
      </template>
    </span>
  </el-dialog>
</template>

<script>
import fileImg from '@/assets/img/文件@2x.png';
import { services } from '@/service';
export default {
  data() {
    return {
      fileImg,
      loading: false,
      handleType: '',
      file: null,
      tableInfo: {
        page: 1,
        size: 10,
        total: 0,
        type: 1,
        list: [],
        loading: false
      },
      uploadDuplicateNumber: 0,
      uploadSuccess: 0,
      showTypeGroup: false
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    taskInfo: {
      type: Object,
      default: () => null
    },
    courseDetail: {
      type: Object,
      required: true
    }
  },
  watch: {
    showList: {
      handler(val) {
        if (val) {
          this.initTableInfo();
        }
      },
      immediate: true
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        if (this.loading) {
          return false;
        }
        this.$emit('update:show', val);
      }
    },
    showList() {
      return this.taskInfo && this.taskInfo._source.status === 'success';
    },
    showRunning() {
      return this.taskInfo && this.taskInfo._source.status === 'running';
    },
    uniqEnumList() {
      return [
        { label: '按案号去重', type: 1 },
        { label: '按案号标题一致去重', type: 2 },
        // { label: '按相似度去重90%', type: 3 },
        { label: '不去重', type: 4 }
      ];
    }
  },
  methods: {
    initTableInfo() {
      this.tableInfo = {
        page: 1,
        size: 10,
        type: 1,
        total: 0,
        list: [],
        loading: false
      };
      this.showTypeGroup = false;
      this.getTableList();
    },
    async getTableList() {
      try {
        this.tableInfo.loading = true;
        const {
          list = [],
          total = 0,
          uploadDuplicateNumber = 0,
          uploadSuccess = 0
        } = await services.courseware.getTaskCaseList(
          this.courseDetail._id,
          this.taskInfo._id,
          this.tableInfo.type,
          this.tableInfo.page
        );
        this.tableInfo.list = list;
        this.tableInfo.total = total;
        this.uploadDuplicateNumber = uploadDuplicateNumber;
        this.uploadSuccess = uploadSuccess;
        if (!this.showTypeGroup) {
          this.showTypeGroup = uploadDuplicateNumber > 0;
        }
      } catch (err) {
        this.$error(err);
      } finally {
        this.tableInfo.loading = false;
      }
    },
    fileChange(event) {
      const file = event.target.files[0];
      if (file) {
        event.target.value = '';

        if (file.size < 1024 * 1024 * 20) {
          this.file = file;
        } else {
          this.$message.warning('请上传20M以内的文件或文件夹');
        }
      }
    },
    async refreshTaskStatus() {
      await new Promise(resolve => this.$emit('updTask', resolve));
    },
    async createTaskHandle() {
      if (this.loading) {
        return;
      }
      const file = this.file;
      if (!file) {
        this.$message.warning('请先上传文件');
        return;
      }
      try {
        this.handleType = 'create';
        this.loading = true;
        await services.courseware.createImportTask(this.courseDetail._id, file);
        await this.refreshTaskStatus();
        this.file = null;
      } catch (err) {
        this.$error(err);
      } finally {
        this.loading = false;
      }
    },
    async cancelHandle() {
      if (this.loading) {
        return;
      }
      try {
        this.handleType = 'cancel';
        this.loading = true;
        await services.courseware.cancelTaskStatus(this.taskInfo._id);
        await this.refreshTaskStatus();
        this.$message.success('取消成功');
      } catch (err) {
        this.$error(err);
      } finally {
        this.loading = false;
      }
    },
    async confirmHandle() {
      if (this.loading) {
        return;
      }
      try {
        this.handleType = 'confirm';
        this.loading = true;
        await services.courseware.confirmTaskImport(this.taskInfo._id, this.tableInfo.type);
        await this.refreshTaskStatus();
        this.$message.success('导入成功');
        this.$emit('importSuccess');
        this.loading = false;
        this.visible = false;
      } catch (err) {
        this.loading = false;
        this.$error(err);
      }
    },
    downloadPreview() {
      window.open('https://xiaobaogong-small-program.oss-cn-shenzhen.aliyuncs.com/实证案件导入示例.doc', '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.case-import-modal {
  .import-list-content {
    .pagination-content {
      text-align: center;
      margin-top: 10px;
    }

    .import-table-content {
      border: 1px solid #ebeef5;
      border-bottom: 0;
      margin-top: 10px;

      ::v-deep .el-table {
        .el-table__header-wrapper {
          th {
            background-color: #f8fafd;
          }
        }
        .duplicate-item {
          background: #f56c6c;
        }
      }
    }
  }

  .import-content {
    .import-content-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: #3d465a;
      line-height: 20px;
    }

    .upload-content {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      height: 260px;
      text-align: center;
      border: 1px solid #e8ebef;
      border-radius: 4px;
      margin-top: 6px;
      padding: 20px;
      overflow: hidden;

      .upload-btn {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        z-index: 2;
        cursor: pointer;
      }

      .upload-file-img {
        width: 36px;
        height: 30px;
        margin-top: 70px;
      }

      .upload-tip-title {
        font-size: 14px;
        color: #2c3443;
        line-height: 20px;
        margin-top: 16px;
      }

      .upload-tip-desc {
        font-size: 12px;
        color: #9599a5;
        line-height: 18px;
        margin-top: 6px;
      }
    }
  }
}
</style>
